import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(
  (theme) => ({
    suggestions: {
      marginTop: theme.spacing(1)
    },
    'suggestions-heading': {
      margin: 0,
      marginBottom: theme.spacing(0.5),
      fontSize: '0.7rem',
      fontWeight: 600,
      letterSpacing: '0.04em',
      textTransform: 'uppercase',
      color: theme.palette.text.secondary
    },
    'suggestions-list': {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: theme.shape.borderRadius,
      overflow: 'hidden'
    },
    'suggestions-item': {
      borderBottom: `1px solid ${theme.palette.divider}`,

      '&:last-child': {
        borderBottom: 'none'
      }
    },
    'suggestions-button': {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      width: '100%',
      border: 'none',
      background: 'transparent',
      textAlign: 'left',
      font: 'inherit',
      color: theme.palette.text.primary,
      padding: theme.spacing(1.25, 1.5),
      cursor: 'pointer',

      '&:hover': {
        backgroundColor: theme.palette.action.hover
      },
      '&:focus-visible': {
        outline: '2px solid #295BFF',
        outlineOffset: '-2px'
      }
    },
    'suggestions-pin': {
      flex: 'none',
      fontSize: '1.1rem',
      color: theme.palette.text.secondary
    }
  }),
  { name: 'autocomplete-address-' }
)

export default useStyles
